export const styles = {
  container:
    "bg-card border-none !w-[1150px] max-w-[1200px] lg:!w-[1200px] !p-2 bg-[#F6F9FF] rounded-xl",
  centeredModal:
    "!bottom-auto !top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-300",
  header: "px-8 pt-6 pb-2",
  headerDivider: "h-px bg-[#E5ECFF] mx-8 mb-6",
  headerTitle: "text-[20px] font-semibold text-[#0F172A]",
  headerSubTitle: "text-sm text-[#5E718D] mt-1",
  body: "px-8 pb-8 pt-4 flex-1 min-h-0 flex flex-col",
  content: "grid grid-cols-1 lg:grid-cols-5 gap-6 flex-1 min-h-[560px]",
  documentList:
    "relative overflow-auto lg:col-span-2 bg-white rounded-2xl shadow-[0px_10px_30px_rgba(15,23,42,0.08)] p-4 border border-[#EEF4FF] min-h-[520px] h-full",
  documentItem:
    "relative flex items-center w-full px-3 py-2 rounded-xl border transition cursor-pointer min-h-[64px]",
  uploadSection:
    "lg:col-span-3 bg-white rounded-2xl shadow-[0px_10px_30px_rgba(15,23,42,0.08)] p-4 border border-[#EEF4FF] min-h-[520px] h-full",
  uploadGrid: "grid grid-cols-1 md:grid-cols-2 gap-4",
  uploadCard:
    "border border-dashed border-[#D0DBFF] rounded-2xl bg-[#F8FBFF] p-4 flex items-center justify-start gap-3 text-left w-full min-h-[96px]",
  uploadCardSuccess: "!border-2 border-solid !border-[#22C55E] !bg-[#F0FDF4]",
  inputRow: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-4",
  inputWrapper: "relative",
  textInput:
    "w-full rounded-xl border border-[#D3DEFF] bg-white px-4 py-3 text-sm placeholder:text-[#94A3B8] focus:outline-none focus:border-[#3C7CFF]",
  verifyButton:
    "w-full rounded-xl bg-gradient-to-r from-[#4E8AFF] to-[#1E5BFF] text-white py-3 font-semibold shadow-[0px_15px_30px_rgba(76,131,255,0.3)]",
  submitFooter: "flex justify-end pt-4",
  submitButton:
    "px-8 py-3 rounded-xl bg-gradient-to-r from-[#4E8AFF] to-[#1E5BFF] text-white font-semibold shadow-[0px_12px_25px_rgba(76,131,255,0.35)]",
};
